<script>
    import PageHeader from "./PageHeader.svelte";
    import CardImovel from './CardImovel.svelte';

    export let filters = {};
    export let afterLoadRealties = null;
    export let showPaginator = true;
    
    let pages = [];
    
    function pageChange(newPage) {
        filters = {...filters, currentPage:newPage}
        scrollTo('.lista-imoveis');
    }
    async function getRealties(filters) 
    {
        console.log('getRealties');
        console.log(filters);
        let url = `${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=realties&callback=null&`;
        url += Object.entries(filters).map(e=>`${e[0]}=${e[1]}`).join('&');
        let response = await fetch(url,{
            method: 'GET',
            mode: 'cors'
        });
        let data = await response.json()
        return data;
    }

    $: imoveis = getRealties(filters).then(json => {
        pages = new Array(json.NumberOfPages).fill(null).map((v, i)=> (i + 1));

        if (afterLoadRealties != null) {
            afterLoadRealties(json);
        }

        return json;
    });

   //.filter(i => i.tipo_negociacao == filters.tipo_negociacao);
</script>

<div class="mt-30">
    {#await imoveis}
        <!-- Tela de carregamento dos Imóveis -->
        <div class="row">
            <div class="col-xs-12 col-md-6 col-lg-4 mb-20">
                <CardImovel loading={true} />
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 mb-20">
                <CardImovel loading={true} />
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 mb-20">
                <CardImovel loading={true} />
            </div>
        </div>
    {:then data}
        <!-- Imóveis -->
        <div class="row">
            {#each data.Items as imovel}
                <div class="col-xs-12 col-md-6 col-lg-4 mb-20">
                    <CardImovel realty={imovel} />
                </div>
            {:else}
                <div class="col">
                    <p>Nenhum imóvel encontrado.</p>
                </div>
            {/each}
        </div>
        <!-- Paginação -->
        {#if data.NumberOfPages > 1 && showPaginator}
            <nav aria-label="pagination">
                <ul class="pagination justify-content-center mt-30">
                    {#each pages as page, i}
                        {#if page === data.CurrentPage}
                            <li class="page-item active">
                                <a class="page-link" aria-label="Página atual: {page}}" href="javascript:void();">{page}</a>
                            </li>
                        {:else}
                            <li>
                                <a class="page-link" aria-label="Vai para página: {page}" href="javascript:void();" on:click={()=>{pageChange(page)}}>{page}</a>
                            </li>
                        {/if}               
                    {/each}
                </ul>
            </nav>
        {/if}
    {/await}
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

// Paginação 
.pagination
    flex-wrap: wrap
    
.page-item.active .page-link
    background-color: $color-secondary
    border-color: $color-secondary
.page-link
    color: $color-secondary

</style>